// @index(['./**/*.ts', '!./**/*.{spec,test}.ts','!./**/index.ts'], f => `export * from '${f.path}.js'`)
export * from './lib/resource-metadata-manager.js';
export * from './lib/set-resource-metadata.decorator.js';
